<template>
  <section class="mobile-menu only-mobile">
    <input type="checkbox" class="nav-check" id="check"/>
    <label id="nav-icon" for="check">
      <span></span>
      <span></span>
      <span></span>
    </label>
    <div class="mobile-menu-container">
      <library-logo />
      <ul class="menu-list">
        <li class="menu-list-item">
            <img src="@/assets/images/user_grey_dark_icon.svg" alt="user icon">
          <p class="user-name">
            {{ fullName }}
          </p>
        </li>
        <li class="menu-list-item lang">
          <button class="button-lang" @click.stop="openLangOptions">
            <img
              src="@/assets/images/world.svg"
              class="icon-world"
            />
            <span class="text">
                {{ $t("LANGUAGE") }}
              </span>
            <img
              src="@/assets/images/arrow_filter_side_bar.svg"
              class="arrow-down" :class="{'open':isLangOpen}"
            />
          </button>
        </li>
        <li>
          <ul class="lang-dropdown" v-if="isLangOpen">
            <li
              class="content"
              v-for="(langObj, index) in langOptions"
              :key="index"
              @click="selectLang(langObj)"
            >
              {{ langObj.lang }}
            </li>
          </ul>
        </li>
        <li class="menu-list-item products">
<!--          <button-->
<!--            class="products-menu-button"-->
<!--            @click="openClaseeProducts"-->
<!--          >-->
<!--            <span class="products-menu-icon"></span>-->
<!--            <p class="text">-->
<!--              {{$t('CLASSE_PRODUCTS')}}-->
<!--            </p>-->
<!--            <img-->
<!--              src="@/assets/images/arrow_filter_side_bar.svg"-->
<!--              class="arrow-down"-->
<!--              :class="{ open: isClasseProductsOpen }"-->
<!--            />-->
<!--          </button>-->
          <div class="products-container" v-if="isClasseProductsOpen">
            <div class="products-container-inner">
              <div
                v-for="availableLibrary in availableLibraries"
                :key="availableLibrary.id"
              >
                <router-link
                  class="product"
                  :to="'/' + availableLibrary.slug + '/base/'"
                  replace>
                  <img :src="availableLibrary.logo_url" class="icon" alt="icon" />
                  <span class="text"> {{ availableLibrary.title }} </span>
                </router-link>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <button class="sign-out-button" @click="signOut">
          <span class="text">
            {{$t('SIGN-OUT')}}
          </span>
      </button>
    </div>
  </section>
</template>

<script>
import LibraryLogo from '@/components/library-logo'
import { mapActions, mapState } from 'vuex'
import { langObjArr } from '@/constants.js'

export default {
  name: 'mobile-menu',
  data () {
    return {
      isLangOpen: false,
      isClasseProductsOpen: false,
      langOptions: langObjArr
    }
  },
  components: { LibraryLogo },
  computed: {
    ...mapState({
      user: state => state.base.user,
      toggleBaseMenu: state => state.base.toggleBaseMenu,
      availableLibraries: state => state.base.availableLibraries
    }),
    fullName () {
      return this.user.firstName + ' ' + this.user.lastName
    }
  },
  methods: {
    ...mapActions({
      setLanguage: 'setLang',
      toggleBaseLibraryMenu: 'toggleBaseLibraryMenu'
    }),
    signOut () {
      this.$store.dispatch('signOut')
      this.$router.push({ name: 'homePage' })
    },
    openClaseeProducts () {
      this.isClasseProductsOpen = !this.isClasseProductsOpen
    },
    openLangOptions () {
      this.isLangOpen = !this.isLangOpen
    },
    selectLang (lang) {
      this.setLanguage(lang)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "src/assets/styles/cssComponents/variables/variables" as v;
.lang-dropdown{
  .content{
    display: flex; gap: 8px; flex-wrap: nowrap; align-items: center; height: 37px; line-height: 37px; padding: 0 15px;
    &:first-child{border-bottom: 1px solid v.$lite-border-color;}
    &:not(:first-child){
      cursor: pointer;
      &:hover{
        background-color: #DCF2FF;
        .text{color: v.$black;}
      }
    }
  }
    .mobile-menu &{padding-inline-start: 56px;}
  }
.mobile-menu .menu-list-item .arrow-down{
  transition: all 0.4s;
  &.open{transform: rotate(-180deg);}
}
</style>
